<app-input-wrapper [fc]="fc" [label]="label">
  <select class="input select-input" [formControl]="fc">
    <option *ngIf="emptyOption" [ngValue]="null" disabled>
      {{ "please_select" | t }}
    </option>
    <option *ngFor="let option of options" [ngValue]="option.id">
      {{ option.itemName }}
    </option>
  </select>
  <p *ngIf="note" class="light text-small">{{ note }}</p>
</app-input-wrapper>
